<div class="mc-avatar-tooltip-container" [matTooltip]="commitId$ | async" [matTooltipDisabled]="disabledTooltip || !(commitId$ | async)">
  <div *ngIf="showAvatar" class="mc-avatar-container">
    <mat-icon class="mc-avatar-icon" fontSet="project-titan" fontIcon="icon-commit-horizontal"></mat-icon>
  </div>
  <span *ngIf="showName" class="mc-avatar-name">{{ commitId$ | async }}</span>
</div>